/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

const outerHeight = 316;

(function brandsQuickShow() {
  const alphabetsList = document.querySelector("#Quick_Show ul");
  if (alphabetsList == null) return;
  const buttonAfter = document.querySelector("#Quick_Show .sticky .after");
  const buttonBefore = document.querySelector("#Quick_Show .sticky .before");
  const scroller = document.querySelector("#Quick_Show .sticky .scroller ul");

  alphabetsList.addEventListener("click", function (e) {
    const id = e.target.innerHTML;

    window.scrollTo({
      top: document.querySelector(`#${id}`).getBoundingClientRect().top + window.scrollY,
      behavior: "smooth",
    });
  });

  buttonAfter.addEventListener("click", function (e) {
    scroller.style.top = `${outerHeight - alphabetsList.offsetHeight}px`;

    buttonAfter.style.display = "none";
    buttonBefore.style.display = "block";
  });

  buttonBefore.addEventListener("click", function (e) {
    scroller.style.top = 0;

    buttonAfter.style.display = "block";
    buttonBefore.style.display = "none";
  });
})();

/**
 * Keep the mobile navigation inside the visible viewport.
 *
 * The menu is positioned below the header, so a fixed 100vh height extends its
 * bottom past the screen. Safari's dynamic browser chrome makes this worse.
 */
(function mobileMenuViewportFix() {
  const mobileMenu = document.getElementById("mobile-menu");
  if (mobileMenu == null) return;

  const updateMobileMenuHeight = function () {
    const viewportHeight = window.visualViewport
      ? window.visualViewport.height
      : window.innerHeight;
    const menuTop = Math.max(0, mobileMenu.getBoundingClientRect().top);
    const availableHeight = Math.max(0, Math.floor(viewportHeight - menuTop));

    mobileMenu.style.setProperty("height", `${availableHeight}px`);
    mobileMenu.style.setProperty("max-height", `${availableHeight}px`, "important");
  };

  const observer = new MutationObserver(function (mutations) {
    if (mutations.some(function (mutation) {
      return mutation.attributeName === "aria-hidden";
    })) {
      window.requestAnimationFrame(updateMobileMenuHeight);
    }
  });

  observer.observe(mobileMenu, {
    attributes: true,
    attributeFilter: ["aria-hidden"],
  });

  window.addEventListener("resize", updateMobileMenuHeight, { passive: true });

  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", updateMobileMenuHeight, {
      passive: true,
    });
    window.visualViewport.addEventListener("scroll", updateMobileMenuHeight, {
      passive: true,
    });
  }

  updateMobileMenuHeight();
})();

/* Match the drawer height to the viewport below its actual top edge. */
(function () {
  var scheduled = false;
  function fitCart() {
    scheduled = false;
    var cart = document.getElementById('mini-cart');
    if (!cart || cart.getAttribute('aria-hidden') !== 'false') return;
    var viewport = window.visualViewport;
    var bottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
    var top = cart.getBoundingClientRect().top;
    var available = Math.max(0, Math.floor(bottom - top - 12));
    cart.style.setProperty('--bd-mini-cart-space', available + 'px');
    var content = cart.querySelector('.mini-cart__content');
    var recap = cart.querySelector('.mini-cart__recap');
    if (content) content.style.maxHeight = Math.max(0, available - (recap ? recap.offsetHeight : 0)) + 'px';
  }
  function scheduleFit() {
    if (!scheduled) { scheduled = true; window.requestAnimationFrame(fitCart); }
  }
  function initCartFit() {
    var header = document.getElementById('shopify-section-header');
    if (header) new MutationObserver(scheduleFit).observe(header, {subtree:true,childList:true,attributes:true,attributeFilter:['aria-hidden']});
    if (header) header.addEventListener('transitionend', function (event) {
      if (event.target.id === 'mini-cart' && event.propertyName === 'transform') scheduleFit();
    });
    window.addEventListener('pageshow', scheduleFit);
    window.addEventListener('orientationchange', scheduleFit);
    window.addEventListener('resize', scheduleFit);
    window.addEventListener('scroll', scheduleFit, {passive:true});
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', scheduleFit);
      window.visualViewport.addEventListener('scroll', scheduleFit);
    }
    scheduleFit();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCartFit);
  else initCartFit();
})();
